import { render, staticRenderFns } from "./showClients.vue?vue&type=template&id=142ac703"
import script from "./showClients.vue?vue&type=script&lang=js"
export * from "./showClients.vue?vue&type=script&lang=js"
import style0 from "./showClients.vue?vue&type=style&index=0&id=142ac703&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports